import React, { FC } from 'react';
import { DeleteForeverRounded, ClearRounded, AccountTree } from '@mui/icons-material';
import { ControlPointObjectType, SectionsObjetType } from '../../constructor/types';
import { ItemMenuComponentType, MenuComponent } from '../MenuComponent';
import { Edit } from '../../constructor/work/Edit';
import { useHandlerNotificationApp } from '../../hooks/useHandlerNotificationApp';

interface Props {
  positionX: number;
  positionY: number;
  selectedObjectPoint?: ControlPointObjectType | null;
  closeMenu(): void;
}
type ActionsType = 'delete' | 'close' | 'add point' | '';
export const MenuCircle: FC<Props> = ({ positionX, positionY, closeMenu, selectedObjectPoint }) => {
  const { addNotification } = useHandlerNotificationApp();
  const deleteControlPoint = () => {
    if (selectedObjectPoint) {
      const parent = selectedObjectPoint?.parent as SectionsObjetType;
      if (parent) {
        parent.removeControlPoint(selectedObjectPoint);
      }
    }
  };
  const addLineConnectedPoints = () => {
    if (selectedObjectPoint) {
      if (selectedObjectPoint?.linkPointBridge) {
        addNotification({
          messageError: 'Эта точка уже является частью пересечения сектора. Выберите другую.',
          typeMessage: 'error',
        });
      } else {
        Edit.createLineObject(selectedObjectPoint);
      }
    }
  };

  const ItemsMenu: Array<ItemMenuComponentType<ActionsType>> = [
    { title: 'delete', icon: <AccountTree />, onClickMenuItem: addLineConnectedPoints },
    { title: 'close' },
    { title: 'close', icon: <DeleteForeverRounded />, onClickMenuItem: deleteControlPoint },
    { title: 'add point' },
    { title: 'close', icon: <ClearRounded /> },
  ];
  return (
    <MenuComponent
      positionX={positionX}
      positionY={positionY}
      itemsMenu={ItemsMenu}
      closeMenu={closeMenu}
    />
  );
};
